<template>
    <SideNav ref="modal" class="news" @close="onClose">
        <div class="close" @click="onClose"></div>

        <HorizontalTab v-model="activeTab" :elements="tabList" class="tabs">
            <template #title="{ title, item }">
                <div class="tab-item">
                    <span class="title">{{ title }}</span>
                    <span v-show="item.id === 'news' && unreadNewsCount" class="dot circle-marker" />
                    <span v-show="item.id === 'notify' && unreadNotifyCount" class="dot circle-marker" />
                </div>
            </template>
            <template #tab-news>
                <NewsList ref="news"
                          class="overflow"
                          @closeModal="onClose"
                          @updateSubscriptions="updateSubscriptions" />
            </template>
            <template #tab-subscriptions>
                <Subscriptions ref="subscriptions"
                               class="overflow"
                               @closeModal="onClose"
                               :show-confirm="$refs.modal?.showConfirm ?? (() => ({}))"
                               @updateNews="updateNews" />
            </template>
            <template #tab-notify>
                <NotificationList ref="notify"
                                  class="overflow"
                                  @closeModal="onClose" />
            </template>
        </HorizontalTab>
    </SideNav>
</template>

<script>
import { EDIT_CARD } from '@/common/rights.js';
import { hasRights } from '@/common/session.js';
import NewsList from '../NewsTab/NewsList.vue';
import Subscriptions from '../SubTab/SubscriptionsList.vue';
import NotificationList from '../NotifyTab/NotificationList.vue';

const TAB_LIST = [
    { id: 'news', title: 'Новости', right: [] },
    { id: 'subscriptions', title: 'Подписки', right: [] },
    { id: 'notify', title: 'Уведомления', right: [ EDIT_CARD ] },
];

export default {
    name: 'News',
    components: {
        NotificationList,
        Subscriptions,
        NewsList,
    },
    data() {
        return {
            activeTab: null,
        };
    },
    inject: {
        unreadNewsCount: {
            type: Number,
            default: null,
        },
        unreadNotifyCount: {
            type: Number,
            default: null,
        },
    },
    computed: {
        tabList() {
            return TAB_LIST.filter((it) => hasRights(it.right));
        },
        editCard() {
            return hasRights([ EDIT_CARD ]);
        },
    },
    methods: {
        open(tab) {
            this.updateNews();
            this.updateSubscriptions();

            if (tab)
                this.activeTab = tab;

            if (!this.activeTab)
                this.activeTab = this.tabList[0].id;

            this.$refs.modal.open();
        },
        onClose() {
            this.$emit('close');
        },
        async close() {
            await this.$refs.news.sendRead();

            if (this.editCard) {
                await this.$refs.notify.sendRead();
                this.$refs.notify.filterSheet = 'HIDDEN';
            }

            this.$refs.modal.accept();
        },
        updateNews() {
            this.$refs.news.resetSearch();
        },
        updateSubscriptions() {
            this.$refs.subscriptions.resetSearch();
        },
    },
    watch: {
        activeTab: {
            immediate: true,
            handler(tab) {
                // метрика
                try {
                    if (tab === 'subscriptions')
                        this.$metrika.hit('subscriptions');
                } catch (e) {
                    console.error('Не удалось отправить метрику: ' + e);
                }
            },
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@dsee/mixins.scss';
@import '@/common/comp/horizontal_tabs/horizontal_tab';


$margin_news: 12px;
$height_tabs: 60px;
$padding_bottom_scroll: 10px;

.news {
    margin: $margin_news $margin_news $margin_news -32px;
    height: calc(100vh - 24px);
    max-width: 518px;
    width: 100%;
    overflow: hidden;
    padding: 0;
    border-radius: 24px;
    background-color: #fff;
    box-sizing: border-box;
    position: relative;

    @include horizontal-tab-full-height;

    :deep(.tabs  .tab-list-container) {
        margin-left: 32px;
    }

    .close {
        @include icon(24px, 24px);
        position: absolute;
        background-image: url(~@/common/icons/close.svg);
        top: 16px;
        right: 16px;
        z-index: 1;
    }

    .overflow {
        height: calc(100vh - ($height_tabs + $margin_news + $padding_bottom_scroll)); // мэджик

        :deep(.scroll) {
            overflow: auto;
            padding-bottom: $padding_bottom_scroll;
            overflow-wrap: anywhere;
        }
    }

    .tabs {
        .tab-item {
            position: relative;

            .dot {
                position: absolute;
                top: 4px;
                margin-left: 2px;
                width: 4px;
                height: 4px;
                background-color: #FF2626;
            }
        }
    }
}
</style>
